import { TemplateRef, ViewContainerRef } from '@angular/core';

export type CueDateTimePickerActiveTab = 'date' | 'time';
export type CueDateTimePickerAdaptiveMode = 'none' | 'auto';
export type CueDateTimePickerCalendarType = 'classic' | 'infinite';
export type CueDateTimePickerFillMode = 'solid' | 'flat' | 'outline';
export type CueDateTimePickerRounded = 'small' | 'medium' | 'large' | 'full' | 'none';
export type CueDateTimePickerSize = 'small' | 'medium' | 'large';
export type CueDateTimePickerWeekDaysFormat = 'short' | 'narrow' | 'abbreviated';
export type CueDateTimePickerCalendarView = 'month' | 'year' | 'decade' | 'century';

export type CueDateTimePickerDay = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export type CueDateTimePickerDisabledDates = Date[] | CueDateTimePickerDay[] | ((date: Date) => boolean);

export interface CueDateTimePickerFormatSettings {
  inputFormat: string;
  displayFormat: string;
}

export interface CueDateTimePickerIncrementalSteps {
  year?: number;
  month?: number;
  day?: number;
  hour?: number;
  minute?: number;
  second?: number;
  millisecond?: number;
}

export interface CueDateTimePickerCustomFormatPlaceholder {
  year?: string;
  month?: string;
  day?: string;
  hour?: string;
  minute?: string;
  second?: string;
  millisecond?: string;
}

export type CueDateTimePickerFormatPlaceholder =
  | 'wide'
  | 'narrow'
  | 'short'
  | 'formatPattern'
  | CueDateTimePickerCustomFormatPlaceholder;

export interface CueDateTimePickerPopupSettings {
  animate?: boolean;
  appendTo?: 'root' | 'component' | ViewContainerRef;
  popupClass?: string | string[] | Record<string, boolean> | Set<string>;
}

export interface CueDateTimePickerMessages {
  accept: string;
  cancel: string;
  clear: string;
  dateTab: string;
  hour: string;
  minute: string;
  nextPeriod: string;
  open: string;
  previousPeriod: string;
  second: string;
  timeTab: string;
  today: string;
}

export interface CueDateTimePickerCellContext {
  $implicit: Date;
  date: Date;
  disabled: boolean;
  outsideCurrentPeriod: boolean;
  selected: boolean;
  today: boolean;
}

export interface CueDateTimePickerWeekNumberContext {
  $implicit: number;
  weekNumber: number;
  weekStart: Date;
}

export interface CueDateTimePickerTemplates {
  cell?: TemplateRef<CueDateTimePickerCellContext>;
  centuryCell?: TemplateRef<CueDateTimePickerCellContext>;
  decadeCell?: TemplateRef<CueDateTimePickerCellContext>;
  footer?: TemplateRef<unknown>;
  header?: TemplateRef<unknown>;
  headerTitle?: TemplateRef<{ $implicit: string; title: string }>;
  monthCell?: TemplateRef<CueDateTimePickerCellContext>;
  weekNumber?: TemplateRef<CueDateTimePickerWeekNumberContext>;
  yearCell?: TemplateRef<CueDateTimePickerCellContext>;
}

export class CueDateTimePickerPreventableEvent {
  private prevented = false;

  preventDefault(): void {
    this.prevented = true;
  }

  isDefaultPrevented(): boolean {
    return this.prevented;
  }
}
